/**
 * コモンクラス
 * @constructor
 */
import AOS from 'aos';
class Common {
  constructor() {
    this.sct =$(window).scrollTop();
    this.target = $('.l-aboutFloat__box');
    if (!document.querySelector('main#shiryo5')) {
      this.ost = $('.l-about').offset().top;
      this.aboutH = $('.l-about').height();
    }
    this.wh = window.innerHeight;
  }
  /**
   * コモン
   */
  init() {
    this.floatCt();
    this.aosSet();
    this.spMenu();
  }
  spMenu(){
    $('.l-spMenuBtn').find('a').on('click',()=>{
      $('.l-spMenu').addClass('is-active');
    });
    $('.js-modalClose').find('a').on('click',()=>{
      $('.l-spMenu').removeClass('is-active');
    });
    $('.l-spMenuList__item').find('a').on('click',()=>{
      $('.l-spMenu').removeClass('is-active');
    })
  }
  aosSet(){
    AOS.init({
      duration: 400,
      easing: 'ease-out',
      offset: 100,
      delay: 400,
    });
  }
  floatCt(){
    if(this.sct > this.ost && this.sct+this.wh < this.ost+this.aboutH+50){
      let move = this.sct - this.ost;
//      console.log('★'+move)
      this.target.css('top',move+'px');
    }
    $(window).on('scroll resize load',()=>{
      this.sct = $(window).scrollTop();
      if (!document.querySelector('main#shiryo5')) {
        this.ost = $('.l-about').offset().top;
        this.aboutH = $('.l-about').height();
      }
      this.wh = window.innerHeight;
      if(this.sct > this.ost && this.sct+this.wh < this.ost+this.aboutH+50){
        let move = this.sct - this.ost;
//        console.log('★'+move)
        this.target.css('top',move+'px');
      }
    })
  }
}

export default Common;
